module.exports = __webpack_public_path__ + "img/pailie5_icon.d96d6d09.png";